import blastApi from '@features/flows/api/blast-api';

export type SynthesizeMappingResult = {
  mappingLiquid?: Record<string, string>;
  jsonata?: string;
  info?: {
    iterations?: number;
    latencyMs?: number;
    cache?: { hit: boolean; key?: string };
    traceId?: string;
    usage?: {
      model?: string;
      input_tokens?: number;
      output_tokens?: number;
      cost_usd?: number;
      cached?: boolean;
    };
  };
};

export async function synthesizeMapping(opts: {
  srcSchema?: unknown;
  dstSchema?: unknown;
  unresolved?: string[];
  resolved?: string[];
  currentLiquid?: Record<string, string>;
  message?: string;
}): Promise<SynthesizeMappingResult> {
  try {
    const res = await blastApi.synthesizeAutocast({
      source_schema: opts.srcSchema,
      target_schema: opts.dstSchema,
      liquid: opts.currentLiquid,
      unresolved: Array.isArray(opts.unresolved) ? opts.unresolved : [],
      resolved: Array.isArray(opts.resolved) ? opts.resolved : undefined,
      message: opts.message,
    });

    return {
      mappingLiquid: res.liquidMappings ? { ...res.liquidMappings } : undefined,
      jsonata: typeof res.jsonata === 'string' ? res.jsonata : undefined,
      info: {
        iterations: res.iterations,
        latencyMs: res.latency_ms,
        cache: res.cache,
        traceId: res.trace_id,
        usage: res.usage,
      },
    };
  } catch (err) {
    console.warn('synthesizeMapping failed', err);
    return {};
  }
}
